import i18n from "../i18n/i18n";

export const validateTopUpInput = ({ selectedAmount, voucher, promoDiscount = 0, currency = "" }) => {
  if (!selectedAmount || selectedAmount <= 0) {
    return i18n.t("errors.selectAmount", "Select amount");
  }
  if (promoDiscount > 0 && selectedAmount < promoDiscount) {
    return i18n.t("errors.amountMinPromo", "Amount must be ≥ promo {{promoDiscount}} {{currency}}", { promoDiscount, currency });
  }
  return null;
};

export function parseTopUpError(error) {
  const status = error?.status || error?.response?.status;
  const detail = error?.message || error?.response?.data?.detail || error?.response?.data?.error || "Top-up failed.";

  if (typeof detail === "string") {
    if (detail.toLowerCase().includes("insufficient funds")) {
      return i18n.t("errors.insufficientFunds", "Insufficient funds for this operation.");
    }
    if (detail.toLowerCase().includes("invalid wallet")) {
      return i18n.t("errors.invalidWallet", "Invalid wallet ID.");
    }
    if (detail.toLowerCase().includes("invalid provider")) {
      return i18n.t("errors.paymentProviderUnavailable", "Payment provider not available.");
    }
    if (detail.toLowerCase().includes("promocode") || detail.toLowerCase().includes("voucher")) {
      return i18n.t("errors.invalidOrExpiredVoucher", "Invalid or expired voucher code.");
    }
  }

  if (!status) {
    return i18n.t("errors.connectionError", "Connection error. Please check your internet connection and try again.");
  }

  switch (status) {
    case 400:
      return i18n.t("errors.invalidDataCheckInput", "Invalid data. Please check your input and try again.");
    case 401:
      return i18n.t("errors.sessionExpired", "Your session has expired. Please sign in again.");
    case 403:
      return i18n.t("errors.accessDenied", "You are not authorized to perform this operation.");
    case 422:
      return i18n.t("errors.dataValidationFailed", "Data validation failed. Please check your input.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Payment service is temporarily unavailable. Please try again in a moment.");
    default:
      return i18n.t("errors.topUpFailed", "Top-up failed. Please try again or contact support.");
  }
}
